import { DESTINATIONS } from "../game/destinations";

const MAX_NAME = 32;

// Reads a friend's challenge from the URL (?sfida=<index>&ciurma=<name>), null if absent/invalid.
export const readChallenge = () => {
  const params = new URLSearchParams(window.location.search);
  const raw = params.get("sfida");
  if (raw === null || !/^\d+$/.test(raw)) return null;
  const index = Number(raw);
  if (index >= DESTINATIONS.length) return null;
  const crewName = (params.get("ciurma") || "").trim().slice(0, MAX_NAME);
  return { index, island: DESTINATIONS[index].name, crewName };
};

export const buildChallengeUrl = (index, crewName) => {
  const params = new URLSearchParams({ sfida: String(index) });
  if (crewName) params.set("ciurma", crewName);
  return `${window.location.origin}/?${params.toString()}`;
};

export const CHALLENGE_TITLES = { win: "SFIDA VINTA!", draw: "PAREGGIO!", lose: "SFIDA PERSA" };

export const challengeOutcome = (challenge, destinationIndex) => {
  if (destinationIndex > challenge.index) return "win";
  if (destinationIndex === challenge.index) return "draw";
  return "lose";
};
